import { EstimationMethodology } from '@watershed/constants/finance';

export const EEIO_MODEL_KIND_TO_ESTIMATION_METHODOLOGY_MAP = {
  ceda: EstimationMethodology.CEDA,
  ceda_v5: EstimationMethodology.CEDA_V5,
  ceda_v7: EstimationMethodology.CEDA_V7,
  useeio: EstimationMethodology.USEEIO,
  useeio_2_1: EstimationMethodology.USEEIO_2_1,
  useeio_2_2_22: EstimationMethodology.USEEIO_2_2_22,
};
